document.addEventListener('DOMContentLoaded', function () {
  const bottomMenuButton = document.querySelector(
    '.mobile-bottom-nav .menu-btn'
  );

  if (!bottomMenuButton) return;

  bottomMenuButton.addEventListener('click', function (event) {
    event.preventDefault();

    const drawer = document.querySelector('header-drawer details');

    if (!drawer) {
      console.warn('Header menu drawer not found');
      return;
    }

    const summary = drawer.querySelector('summary');

    if (summary) {
      summary.click();
    }
  });
});

(function () {
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        },
        cache: 'no-store'
      });

      if (!response.ok) return;

      const cart = await response.json();
      const count = cart.item_count;

      // Update every cart count bubble
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        bubble.textContent = count;

        // Hide when cart is empty
        bubble.style.display = count > 0 ? 'flex' : 'none';
      });

      // Also update any elements that use common Shopify cart-count classes
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = count;
      });

    } catch (error) {
      console.error('Unable to update cart count:', error);
    }
  }

  // Watch Shopify AJAX requests
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const requestUrl =
        typeof args[0] === 'string'
          ? args[0]
          : args[0]?.url || '';

      // Shopify AJAX Add to Cart
      if (
        requestUrl.includes('/cart/add') ||
        requestUrl.includes('/cart/add.js')
      ) {
        // Wait for Shopify/theme cart processing to finish
        setTimeout(updateCartCount, 100);
      }

      // Also update after cart changes
      if (
        requestUrl.includes('/cart/change') ||
        requestUrl.includes('/cart/update') ||
        requestUrl.includes('/cart/clear')
      ) {
        setTimeout(updateCartCount, 100);
      }
    } catch (error) {
      console.warn('Cart count listener error:', error);
    }

    return response;
  };

  // Initial count
  updateCartCount();
})();
  
  $('.single-slider .slide-list').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

$(".announcement_close_btn").click(function(){
  $(".announcement-bar-section").addClass("announcement_active");
});


  $('.products-tab-slider .product-tab-list').slick({
  dots: false,
   arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
   responsive: [
     {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
})



$('.customer-slider .customer-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    { 
      breakpoint: 641, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  $(".select_tabs").click(function() {
  var is_open = $(this).hasClass("open");
  if (is_open) {
    $(this).removeClass("open");
  } else {
    $(this).addClass("open");
  }
});

$(".select_tabs li").click(function() {

  var selected_value = $(this).html();
  var first_li = $(".select_tabs li:first-child").html();

  $(".select_tabs li:first-child").html(selected_value);
  $(this).html(first_li);

});

$(document).mouseup(function(event) {

  var target = event.target;
  var select = $(".select_tabs");

  if (!select.is(target)
 && select.has(target).length === 0) {
    select.removeClass("open");
  }

});








$(document).ready(function(){
  $('.marquee-left').marquee({
    direction: 'left',
    duration: 80000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true
  });

  $('.marquee-icon').marquee({
    direction: 'left',
    duration: 20000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true
  });
});